<template>
  <div class="product_list_container">
    <div class="filter_header_container">
      <div class="filter_header">{{ transactionType }} \ Produse</div>
      <div class="new_item_add_button" v-show="allowGridAddNewProduct" @click="addNewItemInstant">
        <i class="fas fa-plus"></i>
      </div>
    </div>
    <DxDataGrid
      :element-attr="gridAttributes"
      ref="productGrid"
      class="product_grid"
      :data-source="dataSource"
      :no-data-text="addNewItemInfoText"
      :show-column-headers="false"
      :hover-state-enabled="true"
      :remote-operations="isRemoteOperation"
      :repaint-changes-only="true"
      :word-wrap-enabled="true"
      :selected-row-keys="gridBoxValue"
      @selection-changed="onGridSelectionChanged($event)"
      @content-ready="onGridContentReady($event)"
      height="100%"
      :columns="dataColumns"
    >
      <DxSelection mode="single" />
      <DxFilterRow :visible="true" />
      <DxPaging :enabled="true" :page-size="30" />
      <DxScrolling mode="infinite" />
      <DxGrouping :autoExpandAll="true" />
      <DxGroupPanel :visible="false" />
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxSelection,
  DxFilterRow,
  DxScrolling,
  DxGrouping,
  DxGroupPanel,
  DxPaging,
} from "devextreme-vue/data-grid";
import { DxScrollView } from "devextreme-vue/scroll-view";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import ArrayStore from "devextreme/data/array_store";
import { v4 } from "uuid";

export default {
  name: "ProductList",
  props: {
    addNewText: {
      type: String,
      default: () => "Produsul nu există",
    },
    allowAddNew: {
      type: Boolean,
      default: () => true,
    },
    localDataset: {
      type: Array,
      default: () => [],
    },
    dataColumns: {
      type: Array,
      default: () => [{ dataField: "name", caption: "Denumire" }],
    },
    hasError: false,
    actionMethod: Function | null,
    filterData: {
      type: Object,
      default: null,
    },
    transactionType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      gridBoxValue: [],
      allowGridAddNewProduct: false,
      gridAttributes: {
        class: "grid_general_mobile_style",
      },
      selectedItem: null,
    };
  },
  components: {
    DxScrollView,
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxFilterRow,
    DxScrolling,
    DxGrouping,
    DxGroupPanel,
    DxPaging,
  },
  computed: {
    hasValueSelected() {
      return this.gridBoxValue && this.gridBoxValue.length > 0;
    },
    addNewItemInfoText() {
      if (this.allowAddNew) {
        return this.addNewText + ", apasă butonul de adăugare!";
      } else {
        return this.addNewText;
      }
    },
    isRemoteOperation() {
      return this.actionMethod instanceof Function;
    },
    dataSource() {
      if (this.isRemoteOperation) {
        return this.customStore;
      }

      return new DataSource({
        store: new ArrayStore({
          key: "uuid",
          data: this.localDataset,
        }),
        pageSize: 30,
      });
    },
    customStore() {
      return new DataSource({
        store: new CustomStore({
          key: "uuid",
          load: async (loadOptions) => {
            const payload = {
              ...loadOptions,
            };

            if (this.filterData && Object.keys(this.filterData).length > 0) {
              Object.assign(payload, this.filterData);
            }

            const result = await this.actionMethod(payload);
            return this.normalizeRemoteResult(result);
          },
          byKey: async function (key) {
            return new Promise((resolve) => resolve("success"));
          },
        }),
      });
    },
  },
  methods: {
    normalizeRemoteResult(result) {
      if (Array.isArray(result)) {
        return {
          data: result,
          totalCount: result.length,
        };
      }

      if (result && Array.isArray(result.data) && Number.isFinite(result.totalCount)) {
        return {
          data: result.data,
          totalCount: result.totalCount,
        };
      }

      if (result && result.data && Array.isArray(result.data.data)) {
        const rows = result.data.data;
        return {
          data: rows,
          totalCount: result.data.pagination?.total ?? rows.length,
        };
      }

      if (result && Array.isArray(result.data)) {
        return {
          data: result.data,
          totalCount: result.pagination?.total ?? result.data.length,
        };
      }

      return {
        data: [],
        totalCount: 0,
      };
    },
    refreshData() {
      this.gridBoxValue = [];
      this.selectedItem = null;
      this.$refs.productGrid?.instance?.refresh();
    },
    gridBoxDisplayExpr(item) {
      return this.selectedItem.name;
    },
    onGridSelectionChanged(e) {
      this.gridBoxValue = e.currentSelectedRowKeys;
      this.selectedItem = e.selectedRowsData[0];

      this.$emit("selectionChanged", this.selectedItem);
      /*if (this.isRemoteOperation) {
        this.$emit("selectionChanged", this.selectedItem);
      } else {
        this.$emit("selectionChanged", this.gridBoxValue);
      }*/
    },
    onGridContentReady(e) {
      if (e.component.getVisibleRows().length <= 0 && this.allowAddNew) {
        this.allowGridAddNewProduct = true;
      } else {
        this.allowGridAddNewProduct = false;
      }
    },
    initNewItem(data) {
      this.selectedItem = data;
      this.gridBoxValue = [data.uuid];
      this.$emit("selectionChanged", data);
    },
    addNewItemInstant() {
      let gridFilter = this.$refs.productGrid.instance.getCombinedFilter();
      let productName = gridFilter && gridFilter.filterValue ? gridFilter.filterValue : "";
      if (productName) {
        this.initNewItem({
          uuid: "NEW_" + v4(),
          name: productName,
          code: "",
          measure_unit: null,
          product_type_uuid: null,
          measure_unit_id: null,
          quantity: 0,
          unit_price: 0,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/dxMobileGridGeneral.scss";

.product_list_container {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  padding-right: 5px;
}
</style>
